import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { FilterConfig as FilterConfigIcon } from '@otp/icons';
import { isEmpty } from '@otp/utils';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '../input';
import { Button } from '../button';
import { Delimiter } from '../delimiter';
import { Box } from '../box';
import styles from './filter.module.css';
import FilterFactory from './filter-factory';
import debounce from 'lodash/debounce';
export const Filter = ({ defaultFilter, items, onChange: onChangeProp, onSubmit: onSubmitProp, submitButtonText = 'Search', loading, searchInputProps, className = '', children, }) => {
    const isDefaultFilterEmpty = isEmpty(defaultFilter || {}, {
        checkNestedKeys: true,
    });
    const { t } = useTranslation();
    const ref = useRef(null);
    const filterValueRef = useRef({});
    const [filter, setFilter] = useState(defaultFilter || {});
    const [showExpandedFilter, setShowExpandedFilter] = useState(!isDefaultFilterEmpty);
    const submitButtonTextTranslated = submitButtonText || t('filter.button-label', 'Search');
    useEffect(() => {
        var _a;
        const onKeyPress = (e) => {
            if (e.charCode === 13) {
                onSubmitProp === null || onSubmitProp === void 0 ? void 0 : onSubmitProp(filterValueRef.current);
                e.preventDefault();
            }
        };
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keypress', onKeyPress);
        return () => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keypress', onKeyPress); };
    }, [onSubmitProp]);
    const onChange = (event) => {
        const { name, value } = event.target;
        setFilter((filter) => {
            const newFilter = Object.assign(Object.assign({}, filter), { [name]: value });
            onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(newFilter);
            filterValueRef.current = newFilter;
            return newFilter;
        });
    };
    const onSubmit = () => {
        onSubmitProp === null || onSubmitProp === void 0 ? void 0 : onSubmitProp(filter);
    };
    const onChangeAndSubmit = debounce((event) => {
        onChange(event);
        onSubmitProp === null || onSubmitProp === void 0 ? void 0 : onSubmitProp(filterValueRef.current);
    }, 500);
    return (_jsxs("div", { className: clsx(styles.filterWrapper, className), ref: ref, children: [_jsxs("div", { className: styles.smallFilterChildrenWrapper, children: [_jsxs("div", { className: styles.smallFilterWrapper, children: [_jsx("div", { className: styles.inputWrapper, children: _jsx(SearchInput, Object.assign({ name: "search", placeholder: t('filter.search-input.placeholder', 'Search by name, email, eID'), label: t('filter.search-input.label', 'Search for...'), defaultValue: filter.search, onChange: onChange, "data-testid": "search-input" }, searchInputProps)) }), !!(items === null || items === void 0 ? void 0 : items.length) && (_jsx("div", { className: styles.iconWrapper, onClick: () => setShowExpandedFilter((expanded) => !expanded), children: _jsx(FilterConfigIcon, {}) })), _jsx(Button, { variant: "contained", onClick: onSubmit, disabled: loading, children: submitButtonTextTranslated })] }), children] }), !!(items === null || items === void 0 ? void 0 : items.length) && (_jsxs("div", { className: clsx(styles.advancedFilterWrapper, {
                    [styles.advancedFilterWrapperOpen]: showExpandedFilter,
                }), children: [_jsx(Delimiter, { text: t('filter.advanced-search-delimiter-text', 'Advanced Search') }), _jsx(Box, { marginTop: 2, children: _jsx(FilterFactory, { items: items, data: filter, onChange: onChangeAndSubmit }) })] }))] }));
};
export default Filter;
